module.exports = __webpack_public_path__ + "static/media/header-containers.4b468ef1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/containers/header-containers.jpg
// module id = 808
// module chunks = 0